/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Title_AccentInputs */

const en_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`range & more.`)
};

const es_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`campo de práctica y más.`)
};

const de_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range & mehr.`)
};

const zh_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场及更多。`)
};

const ar_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان والمزيد.`)
};

const fr_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`practice et plus encore.`)
};

const vi_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sân tập và hơn thế nữa.`)
};

const sw_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uwanja wa mazoezi na zaidi.`)
};

const th_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`และอื่น ๆ`)
};

const bs_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vježbalište i više.`)
};

const ja_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライビングレンジなど。`)
};

const ko_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지 등.`)
};

const pt_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range e muito mais.`)
};

const it_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`campo pratica e altro.`)
};

const sv_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range och mer.`)
};

const nl_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range & meer.`)
};

const da_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range og mere.`)
};

const nb_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range og mer.`)
};

const fi_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range ja paljon muuta.`)
};

const pl_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range i więcej.`)
};

const ru_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`драйвинг-рейндж и многое другое.`)
};

const tr_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range ve daha fazlası.`)
};

const hi_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंज और अधिक।`)
};

const id_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range & lainnya.`)
};

const ms_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range & banyak lagi.`)
};

const cs_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range a další.`)
};

const el_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range και άλλα.`)
};

const he_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מגרש אימונים ועוד.`)
};

const af_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oefenbaan & meer.`)
};

const hu_prices_title_accent = /** @type {(inputs: Prices_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`driving range és még sok más.`)
};

/**
* | output |
* | --- |
* | "range & more." |
*
* @param {Prices_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_title_accent = /** @type {((inputs?: Prices_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_title_accent(inputs)
	if (locale === "de") return de_prices_title_accent(inputs)
	if (locale === "zh") return zh_prices_title_accent(inputs)
	if (locale === "ar") return ar_prices_title_accent(inputs)
	if (locale === "fr") return fr_prices_title_accent(inputs)
	if (locale === "vi") return vi_prices_title_accent(inputs)
	if (locale === "sw") return sw_prices_title_accent(inputs)
	if (locale === "th") return th_prices_title_accent(inputs)
	if (locale === "bs") return bs_prices_title_accent(inputs)
	if (locale === "ja") return ja_prices_title_accent(inputs)
	if (locale === "ko") return ko_prices_title_accent(inputs)
	if (locale === "pt") return pt_prices_title_accent(inputs)
	if (locale === "it") return it_prices_title_accent(inputs)
	if (locale === "sv") return sv_prices_title_accent(inputs)
	if (locale === "nl") return nl_prices_title_accent(inputs)
	if (locale === "da") return da_prices_title_accent(inputs)
	if (locale === "nb") return nb_prices_title_accent(inputs)
	if (locale === "fi") return fi_prices_title_accent(inputs)
	if (locale === "pl") return pl_prices_title_accent(inputs)
	if (locale === "ru") return ru_prices_title_accent(inputs)
	if (locale === "tr") return tr_prices_title_accent(inputs)
	if (locale === "hi") return hi_prices_title_accent(inputs)
	if (locale === "id") return id_prices_title_accent(inputs)
	if (locale === "ms") return ms_prices_title_accent(inputs)
	if (locale === "cs") return cs_prices_title_accent(inputs)
	if (locale === "el") return el_prices_title_accent(inputs)
	if (locale === "he") return he_prices_title_accent(inputs)
	if (locale === "af") return af_prices_title_accent(inputs)
	if (locale === "hu") return hu_prices_title_accent(inputs)
	return en_prices_title_accent(inputs)
});